import CAJA1070ResponseModel from '@/api/data/CAJ/CAJG1070/CAJA1070ResponseModel'
import CAJA1070RequestModel from '@/api/data/CAJ/CAJG1070/CAJA1070RequestModel'
import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

export default class CAJG1070Service {
  /**
   * マンガで学ぶ情報取得
   * @returns APIからのレスポンスデータ
   */
  public async callAPICAJA1070(): Promise<CAJA1070ResponseModel> {
    const caja1070RequestModel: CAJA1070RequestModel =
      new CAJA1070RequestModel()
    const caja1070ResponseModel: CAJA1070ResponseModel = <
      CAJA1070ResponseModel
    > await RestService.post(ApiUrlConstants.CAJA1070, caja1070RequestModel)
    return caja1070ResponseModel
  }
}
